import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/feature/SchemaOrg';
import HeroSection from './components/HeroSection';
import CategoryBar from './components/CategoryBar';
import FeaturedGrid from './components/FeaturedGrid';
import LatestUpdates from './components/LatestUpdates';
import TestimonialSection from './components/TestimonialSection';
import FAQSection from './components/FAQSection';
import { faqs } from '@/mocks/testimonials';

export default function Home() {
  const { t } = useTranslation();

  const faqSchemaData = {
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <SchemaOrg
        type="Organization"
        data={{
          name: '八仔漫画网',
          alternateName: 'Bazai Manhua',
          url: 'http://jisutxt.com/',
          logo: {
            '@type': 'ImageObject',
            url: 'http://jisutxt.com/logo.png',
          },
          description: '八仔漫画网是国内领先的免费漫画在线阅读平台，提供高品质、无广告的纯净漫画阅读体验。',
          foundingDate: '2020',
          contactPoint: {
            '@type': 'ContactPoint',
            contactType: '客户服务',
            email: 'hello@jisutxt.com',
          },
        }}
      />

      <SchemaOrg
        type="WebSite"
        data={{
          name: '八仔漫画网 - 全职法师漫画在线免费阅读漫画全集',
          url: 'http://jisutxt.com/',
          description: '八仔漫画网在线免费阅读全职法师漫画全集，无需付费，无广告干扰，纯净阅读环境，让您沉浸于精彩剧情中。',
          inLanguage: 'zh-CN',
          publisher: {
            '@type': 'Organization',
            name: '八仔漫画网',
          },
          potentialAction: {
            '@type': 'SearchAction',
            target: {
              '@type': 'EntryPoint',
              urlTemplate: 'http://jisutxt.com/search?q={search_term_string}',
            },
            'query-input': 'required name=search_term_string',
          },
        }}
      />

      <SchemaOrg
        type="WebPage"
        data={{
          name: '八仔漫画网 - 全职法师漫画在线免费阅读漫画全集',
          description: '八仔漫画网在线免费阅读全职法师漫画全集，无需付费，无广告干扰，纯净阅读环境，让您沉浸于精彩剧情中。',
          url: 'http://jisutxt.com/',
          isPartOf: {
            '@type': 'WebSite',
            name: '八仔漫画网',
            url: 'http://jisutxt.com/',
          },
          inLanguage: 'zh-CN',
          mainEntity: {
            '@type': 'ItemList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: '全职法师',
                url: 'http://jisutxt.com/comic/quanzhi-fashi',
              },
            ],
          },
        }}
      />

      <SchemaOrg
        type="BreadcrumbList"
        data={{
          itemListElement: [
            {
              '@type': 'ListItem',
              position: 1,
              name: '八仔漫画网',
              item: 'http://jisutxt.com/',
            },
          ],
        }}
      />

      <SchemaOrg type="FAQPage" data={faqSchemaData} />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryBar />
          <FeaturedGrid />
          <LatestUpdates />
          <TestimonialSection />
          <FAQSection />
        </main>
        <Footer />
      </div>
    </>
  );
}